import React from 'react';
import { useSelector } from 'react-redux';
import { RelatedItem } from './related-item';

const RelatedItems = ({data = [], onDelete}) => {
  const language = useSelector(state => state.system.language)

  const check = (val) => {
    if(typeof val === 'string'){
      return val
    } else if(val[language.name]){
      return val[language.name]
    } else {
      return JSON.stringify(val)
    }
  }

  return (
    <div className="flex flex-wrap">
      {
        (data && data.length > 0) &&
        data.map((item) => (
          <div key={item.id} className="mr-4 lg:mr-2 mb-4 lg:mb-2">
            <RelatedItem
              value={check(item.title)}
              onClose={onDelete ? () => onDelete(item.id) : undefined}
            />
          </div>
        ))
      }
    </div>
  )
}

export { RelatedItems }
